import Vue from 'vue';
import EdFormModel from '@/models/ed-form.model';
import EdInputModel from '@/models/ed-input.model';
import {decimal, required, between} from 'vuelidate/lib/validators';

export default Vue.component('ed-homework-grade', {
  name: 'ed-homework-grade',
  props: ['title', 'params'],
  components: {

  },
  data: () => {
    return {
      form: {},
      isSaving: false
    }
  },
  computed: {

  },
  methods: {
    init(grade = 0) {
      this.form = EdFormModel([
        EdInputModel('grade', grade, { required, decimal, between: between(0, 5)})
      ]);
    },
    closeGrade() {
      this.$emit('onClose');
    },
    saveGrade(){
      let data = {
        grade : this.form.grade.value,
        params: this.params
      }
      this.isSaving = true;
      this.$emit('onSave', data);
    }
  },
  created(){
    this.init();
  }
});
